import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as File } from "../../assets/svg/Reporting/fileSvg.svg";
import { ReactComponent as FileChart } from "../../assets/svg/Reporting/fileChart.svg";
import { ReactComponent as KvartalnaStatistika } from "../../assets/svg/Pregledi/KvartalnaStatistika.svg";
import { ReactComponent as Statistika } from "../../assets/svg/Pregledi/Statistika.svg";
import { ReactComponent as Reportdata } from "../../assets/svg/Reporting/report-data.svg";
import Sidebar from "../SideBar";

function ReportsHome() {
  const [helpModal, setHelpModal] = useState(false);
  const location = useLocation();

  const nationalHelpModal = location.pathname.includes("national");

  const menuList = [
    {
      name: "Извештавање",
      icon: <Reportdata />,
      subMenus: [
        {
          name: "Извештавање о прописима",
          title: "Извештавање о прописима",
          url: "/reporting/select-quarter/national",
          select: "/reporting/national/:id",
          icon: <File />,
        },
        {
          name: "Извештавање о мерама",
          title: "Извештавање о мерама",
          url: "/reporting/select-quarter/measures",
          select: "/reporting/measures/:id",
          icon: <FileChart />,
        },
      ],
    },
    {
      name: "Квартална реализ. и статистика",
      icon: <KvartalnaStatistika />,
      subMenus: [
        {
          name: "quartalView",
          title: "По министарствима и посебним организацијама",
          url: "/reporting/quartalview",
          icon: <Statistika />,
        },
      ],
    },
  ];

  return (
    <div className="w-full h-full flex flex-row relative ">
      {/* SIDEBAR */}
      <Sidebar menuList={menuList} />

      {/* OUTLET */}
      <div className="flex-1 w-full overflow-y-scroll gray-small-scroll transition-all duration-300">
        <Outlet />
      </div>
    </div>
  );
}

export default ReportsHome;
